import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { apiClient, extractApiError } from '../api/axios';
import { API } from '../constants/api';

const initialState = {
  rloading: false,
  dloading: false,

  regions: [],
  districts: [],

  error: '',
  regionAvailable: null,
  chrloading: false,
  chrerror: null,

  districtAvailable: null,
  chdloading: false,
  chderror: null,
};

export const fetchRegions = createAsyncThunk('helpers/fetchRegions', async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get(API.helpers.regions);
    return response.data;
  } catch (error) {
    return rejectWithValue(extractApiError(error));
  }
});

export const checkRegion = createAsyncThunk('helpers/checkRegion', async (filter, { rejectWithValue }) => {
  try {
    const response = await apiClient.get(API.vendors.isRegionAvailable, { params: filter });
    return response.data;
  } catch (error) {
    return rejectWithValue(extractApiError(error));
  }
});

export const fetchDistricts = createAsyncThunk('helpers/fetchDistricts', async (id, { rejectWithValue }) => {
  try {
    const response = await apiClient.get(API.helpers.districts(id));
    return response.data;
  } catch (error) {
    return rejectWithValue(extractApiError(error));
  }
});

export const checkDistrict = createAsyncThunk('helpers/checkDistrict', async ({ filter }, { rejectWithValue }) => {
  try {
    const response = await apiClient.get(API.vendors.isDistrictAvailable, { params: filter });
    return response.data;
  } catch (error) {
    return rejectWithValue(extractApiError(error));
  }
});

export const helpersSlice = createSlice({
  name: 'helpers',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchRegions.pending, (state) => {
      state.rloading = true;
      state.error = '';
    });
    builder.addCase(fetchRegions.fulfilled, (state, action) => {
      state.rloading = false;
      state.regions = action.payload;
    });
    builder.addCase(fetchRegions.rejected, (state, action) => {
      toast.error(action.payload);
      state.rloading = false;
    });
    builder.addCase(fetchDistricts.pending, (state) => {
      state.dloading = true;
      state.error = '';
    });
    builder.addCase(fetchDistricts.fulfilled, (state, action) => {
      state.dloading = false;
      state.districts = action.payload;
    });
    builder.addCase(fetchDistricts.rejected, (state, action) => {
      toast.error(action.payload);
      state.dloading = false;
    });
    builder.addCase(checkRegion.pending, (state) => {
      state.chrloading = true;
      state.chrerror = '';
    });
    builder.addCase(checkRegion.fulfilled, (state, action) => {
      state.chrloading = false;
      state.regionAvailable = action.payload;
    });
    builder.addCase(checkRegion.rejected, (state, action) => {
      toast.error(action.payload);
      state.chrloading = false;
      state.chrerror = action.payload;
    });
    builder.addCase(checkDistrict.pending, (state) => {
      state.chdloading = true;
      state.chderror = '';
    });
    builder.addCase(checkDistrict.fulfilled, (state, action) => {
      state.chdloading = false;
      state.districtAvailable = action.payload;
    });
    builder.addCase(checkDistrict.rejected, (state, action) => {
      toast.error(action.payload);
      state.chdloading = false;
      state.chderror = action.payload;
    });
  },
  reducers: {
    setDefault: (state) => {
      state.error = '';
    },
  },
});

export const { setDefault } = helpersSlice.actions;

export default helpersSlice.reducer;
